export const LINK_FOR_PERSONAL_POLICY = 'assets/files/Consent_to_the_processing_of_personal_data.pdf';